import $ from 'jquery';
import * as Sentry from '@sentry/browser';

import { jax } from '~/api/core/legacy';

import {
  storeSetting,
  loadSetting,
} from './common';

const ids_dom = `
<div class='identification identification--loading'>
  <div class=identification__fields >
    <div class='identification__field identification__field--office'>
      <label for=office_id>Office ID</label>
      <ul class=identification__guesses></ul>
    </div>
    <div class='identification__field identification__field--agent'>
      <label for=agent_id>Agent ID</label>
      <ul class=identification__guesses></ul>
    </div>
  </div>
</div>
`;

const bymls_dom = `
  <form action=# class=identification__mls>
    <input type=text class=identification__add-id>
    <input class=identification__search type=submit value=Add>
  </form>
`;

let office_ids_fetched = false;
let agent_ids_fetched = false;
let office_ids = [];
let agent_ids = [];
let timer_save;

function get_id(v, $parent, arr, type, save) {
  jax(
    'get_agent_id_office_id_from_mls',
    { mls_number: v },
    (r) => {
      if (r.office_id !== null || r.agent_id !== null) {
        if (!(r[type] in arr)) {
          const data = {};
          data[type] = r[type];
          jax(
            'get_count_for_office_id_agent_id',
            data,
            (rr) => {
              arr[r[type]] = rr;
              save_setting($parent, type, arr, save);
            },
            (err) => {
              $parent.find('.identification__add-id').attr('disabled', false);
              alert(`Could not add your ${type}`);
              Sentry.captureException(err);
            },
          );
        } else {
          $('.identification__add-id').attr('disabled', false).val('');
          $parent.find(`.identification__guess[data-id="${r[type]}"]`).addClass('there');
          setTimeout(() => {
            $parent.find(`.identification__guess[data-id="${r[type]}"]`).removeClass('there');
          }, 1000);
        }
      } else {
        const data = {};
        data[type] = v;
        jax(
          'get_count_for_office_id_agent_id',
          data,
          (rr) => {
            if (!(rr[type] in arr)) {
              if (v === 'guess') {
                jax(
                  'guess_agent_ids_office_ids',
                  {},
                  (rrr) => {
                    if (type === 'office_id') {
                      Object.keys(rrr.office_id_counts).forEach((vv) => {
                        get_id(vv, $parent, arr, type, true);
                      });
                    } else if (type === 'agent_id') {
                      Object.keys(rrr.agent_id_counts).forEach((vv) => {
                        get_id(vv, $parent, arr, type, true);
                      });
                    }
                  },
                  (err) => {
                    Sentry.captureException(err);
                    $parent.find('.identification__add-id').attr('disabled', false);
                    alert(`Could not add your ${type}`);
                  },
                );
              } else {
                if (rr.count !== '0') {
                  arr[rr[type]] = rr;
                  save_setting($parent, type, arr, save);
                } else {
                  alert('This ID has no listings');
                }
                displayIds(arr, $parent.find('ul'), type);
              }
            } else {
              $('.identification__add-id').attr('disabled', false).val('');
              $parent.find(`.identification__guess[data-id="${rr[type]}"]`).addClass('there');
              setTimeout(() => {
                $parent.find(`.identification__guess[data-id="${rr[type]}"]`).removeClass('there');
              }, 1000);
            }
          },
          (err) => {
            $parent.find('.identification__add-id').attr('disabled', false);
            alert(`Could not add your ${type}`);
            Sentry.captureException(err);
          },
        );
      }
    },
    (err) => {
      $parent.find('.identification__add-id').attr('disabled', false);
      alert(`Could not add your ${type}`);
      Sentry.captureException(err);
    },
  );
}

function find_id($parent, arr, type) {
  const $dom = $(bymls_dom);
  if (type === 'office_id') {
    $dom.find('.identification__add-id').attr('placeholder', 'Enter an Office ID or MLS #');
  } else if (type === 'agent_id') {
    $dom.find('.identification__add-id').attr('placeholder', 'Enter an Agent ID or MLS #');
  }
  $dom.find('input').on('keyup', () => {});
  $dom.on('submit', () => {
    const v = $dom.find('input').val().trim();
    if (v === '') { return false; }
    $dom.find('.identification__add-id').attr('disabled', true);
    get_id(v, $parent, arr, type, true);
    return false;
  });
  $parent.find('label').after($dom);
}

function displayIds(arr, $parentContainer, type) {
  if (type === 'office_id') {
    $('.identification__field--office .identification__add-id').attr('disabled', false).val('');
  } else if (type === 'agent_id') {
    $('.identification__field--agent .identification__add-id').attr('disabled', false).val('');
  }
  $parentContainer.empty();
  Object.keys(arr).forEach((e) => {
    const $dom = $(`
      <li class=identification__guess>
        <span class=identification__did></span>
        <span class=identification__remove></span>
        <span class=identification__tip></span>
      </li>
    `);
    $dom.find('.identification__remove').on('click', () => {
      // eslint-disable-next-line
      if (confirm(`Are you sure you want to remove ${e}?`)) {
        delete arr[e];
        save_setting($parentContainer.parent(), type, arr, true);
      }
    });
    $dom.attr('data-id', e);
    $dom.find('.identification__did').html(e);
    if (arr[e].count === '0') {
      $dom.addClass('undocumented');
    }
    $dom.find('.identification__tip')
      .attr('data-office-name', arr[e].office_name)
      .attr('data-properties', arr[e].count)
      .attr('data-agent-name', arr[e].agent_name);
    $parentContainer.append($dom);
  });
}

function display_ids($parent) {
  displayIds(
    office_ids,
    $parent.find('.identification__field--office .identification__guesses'),
    'office_id',
  );
  displayIds(
    agent_ids,
    $parent.find('.identification__field--agent .identification__guesses'),
    'agent_id',
  );
}

function save_setting($parent, setting, arr, save) {
  timer_save = [];
  if (save) {
    storeSetting(setting, Object.keys(arr).join(','))
      .then(() => {
        $parent.addClass('identification__field--success');
        clearTimeout(timer_save[setting]);
        timer_save[setting] = setTimeout(() => {
          $parent.removeClass('identification__field--success');
        }, 3000);
        displayIds(arr, $parent.find('.identification__guesses'), setting);
      })
      .catch(() => alert(`Could Not Store ${setting}Ids \n Please Try Again`));
  } else { displayIds(arr, $parent.find('.identification__guesses'), setting); }
}

export default function identifications($parent) {
  const $dom = $(ids_dom);

  // TODO: extract out common logic, Promise.all it
  loadSetting('office_id')
    .then((r) => {
      office_ids = [];
      r.split(',')
        .map(e => e.trim())
        .filter(e => e !== '')
        .forEach(e => get_id(
          e,
          $dom.find('.identification__field--office'),
          office_ids,
          'office_id',
          false,
        ));

      office_ids_fetched = true;
      find_id($dom.find('.identification__field--office'), office_ids, 'office_id');
      if (office_ids_fetched && agent_ids_fetched) { display_ids($dom); }
    });
  loadSetting('agent_id')
    .then((r) => {
      $dom.removeClass('identification--loading');
      agent_ids = [];
      r.split(',')
        .map(e => e.trim())
        .filter(e => e !== '')
        .forEach((e) => { get_id(e, $dom.find('.identification__field--agent'), agent_ids, 'agent_id', false); });
      agent_ids_fetched = true;
      find_id($dom.find('.identification__field--agent'), agent_ids, 'agent_id');
      if (office_ids_fetched && agent_ids_fetched) {
        display_ids($dom);
      }
    });
  $parent.append($dom);
}
